import MainCamera from './MainCamera';

export default MainCamera;
